










































































































































































































































import { ClusterList } from '@/core/clusters'
import _ from 'lodash'
import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  props: {
    filter: {
      default: null,
      type: Object,
    },
  },
  computed: {
    ...mapState({
      users: (state: any) => state.users.items,
      statuses: (state: any) => state.statuses.items,
      industries: (state: any) => state.industries.items,
      categories: (state: any) => state.categories.items,
      levels: (state: any) => state.levels.items,
      countries: (state: any) => state.countries.items,
      regions: (state: any) => state.regions.items,
      districts: (state: any) => state.districts.items,
      cities: (state: any) => state.cities.items,
    }),
    clusters() {
      return ClusterList
    },
    duplicates() {
      return [{ value: true, name: 'Да' }]
    },
    booleans() {
      return [
        { value: true, name: 'Да' },
        { value: false, name: 'Нет' },
      ]
    },
  },
  methods: {
    onFilterChange: _.debounce(function(this: any) {
      this.$emit('input', _.omitBy(this.filter, _.isNull))
    }, 250),
  },
})
